export default __webpack_public_path__ + "static/media/Inhouse.abf4cb22.graphql";